import { apiCall } from "../../services/api-service.js";

const dashboardPost = async (endpoint, bodyData) => {
    const response = await apiCall("post", endpoint, bodyData);
    return response?.data;
};

export const getescaltionApi = async (bodayData) => {
    return dashboardPost("dashboard/escalation_tickets", bodayData);
};

export const getApprovalApi = async (bodayData) => {
    return dashboardPost("dashboard/approval_tickets", bodayData);
};

export const getUnallocatedApi = async (bodayData) => {
    return dashboardPost("dashboard/unallocated_tickets", bodayData);
};

export const getLocationReportApi = async (bodayData) => {
    return dashboardPost("dashboard/location_ticket_report", bodayData);
};

export const getRegionReportApi = async (bodayData) => {
    return dashboardPost("dashboard/region_ticket_report", bodayData);
};

export const getTeamReportApi = async (bodayData) => {
    return dashboardPost("dashboard/team_ticket_report", bodayData);
};

export const getProjectReportApi = async (bodayData) => {
    return dashboardPost("dashboard/project_ticket_report", bodayData);
};

